import { render, staticRenderFns } from "./SignOffManagement.vue?vue&type=template&id=1b1f3215&scoped=true"
import script from "./SignOffManagement.vue?vue&type=script&lang=js"
export * from "./SignOffManagement.vue?vue&type=script&lang=js"
import style0 from "./SignOffManagement.vue?vue&type=style&index=0&id=1b1f3215&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1f3215",
  null
  
)

export default component.exports